<template>
  <div class="app">
    <t-navbar
      theme="customer"
      :nav-items="this.$getPrimaryNavItems('profile')"
      :user="authUser"
      v-model="closed"
    >
      <template #header>
        <div v-if="authUser">
          <t-fab
            v-show="!closed"
            data-test-id="header-user-menu"
            class="z-nearest"
            icon="person"
            :user-action="() => {}"
          />
          <div v-show="!closed">
            <p class="mb-0 mt-2">{{ $t("Welcome") }},</p>
            <p class="mb-1">{{ authUser.accountname }}</p>
            <p class="t-small-text">{{ authUser.email }}</p>
          </div>
        </div>
      </template>
    </t-navbar>
    <div ref="app-content" class="app-content" v-if="authUser">
      <main>
        <b-container fluid="lg">
          <t-header hide-user-menu />
          <router-view />
        </b-container>
      </main>
      <t-modal />
      <t-toast />
      <t-alert />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TNavbar from "@/components/TNavbar";
import TModal from "@/components/TModal";

export default {
  components: {
    TNavbar,
    TModal,
  },
  data() {
    return {
      closed: false,
      loading: true,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser", "authUser"]),
  },
  methods: {
    ...mapActions("users", ["fetchCustomerAccounts", "fetchCustomerAccount"]),
    ...mapActions("authentication", ["setAuthUser"]),
    toggleNavigation() {
      this.closed = !this.closed;
    },
    onWindowResize(matchMedia) {
      if (matchMedia.matches && this.closed !== true) {
        this.closed = true;
      }

      if (!matchMedia.matches && this.closed !== false) {
        this.closed = false;
      }
    },
  },
  beforeCreate() {
    const userToken = this.$userPrefs.getCurrentToken();
    if (!userToken) this.$router.push("/");
    this.$http.setAuthorisationToken(userToken);
  },
  async created() {
    const storedSelectedCustomerID = localStorage.getItem("selectedCustomer");
    //if (!storedSelectedCustomerID) this.$router.push("/");

    if (!this.authUser)
      await this.fetchCustomerAccount({ id: storedSelectedCustomerID });

    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  height: 100vh;
  overflow: hidden;

  &-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    footer {
      margin-top: auto;
    }
  }

  .app-content {
    background-color: $bg-light;
  }
}

@media only screen and (max-width: 1200px) {
  .app {
    &-content {
      margin-left: 3.5rem;
    }
  }
}
</style>
